import PropTypes from 'prop-types';
import styles from './cardsStackItem.module.scss';
import { Typography, useMediaQuery } from '@mui/material';
import theme from '../../../../../../../theme';
import clsx from 'clsx';
import { useEffect, useRef } from 'react';

const CardsStackItem = ({
    title,
    closedTitle,
    backgroundColor,
    textColor,
    isSelected,
    unselectedTitlePosition = 'bottom',
    onHeightChange,
    children
}) => {
    const ref = useRef();
    const isMobile = useMediaQuery(theme.breakpoints.down('mobile'));

    useEffect(() => {
        if (onHeightChange) {
            const resizeObserver = new ResizeObserver(() => {
                onHeightChange?.(ref.current.offsetHeight);
            });

            const rootNode = ref.current;
            resizeObserver.observe(rootNode);

            return () => {
                resizeObserver.unobserve(rootNode);
            };
        }
    }, []);

    return (
        <div
            ref={ref}
            className={clsx(styles.card, !isSelected && styles.unselectedCard)}
            style={{ backgroundColor, color: textColor }}>
            <Typography
                fontSize={isMobile ? '38px' : '44px'}
                lineHeight={1}
                fontFamily={'InstrumentSans-semibold'}
                className={clsx(
                    styles.animatedTitle,
                    !isSelected &&
                        unselectedTitlePosition === 'top' &&
                        styles.unselectedAnimatedTitleTop,
                    !isSelected &&
                        unselectedTitlePosition === 'bottom' &&
                        styles.unselectedAnimatedTitleBottom
                )}>
                {isSelected ? title : closedTitle || title}
            </Typography>
            <div className={clsx(!isSelected && styles.hiddenContent)}>
                <Typography
                    fontSize={isMobile ? '38px' : '44px'}
                    lineHeight={1}
                    fontFamily={'InstrumentSans-semibold'}
                    className={clsx(styles.title, !isSelected && styles.unselectedTitle)}>
                    {title}
                </Typography>
                <div className={styles.children}>{children}</div>
            </div>
        </div>
    );
};

CardsStackItem.propTypes = {
    title: PropTypes.string,
    backgroundColor: PropTypes.string,
    children: PropTypes.node,
    unselectedTitlePosition: PropTypes.oneOf(['bottom', 'top']),
    onHeightChange: PropTypes.func
};

export default CardsStackItem;
